module.exports = __webpack_public_path__ + "files/5ad338aa2cb9441489093cfde11c7c87.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/sourcesanspro-bold-webfont.svg
 ** module id = 1010
 ** module chunks = 0
 **/